
import React, { Component } from 'react';
import { BreadCrumbs } from '@components/shared/BreadCrumbs';

export class NotFound extends Component {
    static displayName = NotFound.name;

    constructor(props) {
        super(props);

        this.state = {

        }
        
        this.breadCrumbPath = [
            { text: "Nenalezeno", link: null }
        ];
    }

    componentDidMount() {

    }
    
    render() {
        return (
            <div id='notFound' className=''>
                <BreadCrumbs
                    adm
                    path={this.breadCrumbPath}
                />
                <h1>Stránka s požadovanou url adresou nebyla nenalezena</h1>
                <div className='position-absolute questionmark'>
                    <i className="fa-solid fa-question"></i>
                </div>
            </div>
        );
    }
}
